import { useEffectOnce } from "react-use";
import { useViewerQuery, useViewerXps } from "../queries/viewerQuery";
import { useSetFlag } from "../queries/users/setFlag";
import { STREAK_XPS } from "../sharedJs__generated/constants";
import { NOTIFICATION_REENGAGEMENT_FLAG } from "../queries/users/userFlagsModel";

const TWO_MONTHS_IN_DAYS = 60;

export const useNotificationReengagement = () => {
  const { viewer, getFlag } = useViewerQuery();
  const { xps } = useViewerXps();

  if (!viewer || !xps) return false;

  const hasNotificationsDisabled = viewer.fcmId === null;
  const hasStreakToday = xps.today >= STREAK_XPS;
  const hasAnyXps = xps.total > 0;
  const hasAccountForSomeTime = viewer.createdBeforeDays >= 4;
  const flagExists = !!getFlag(NOTIFICATION_REENGAGEMENT_FLAG);

  return hasNotificationsDisabled && hasAnyXps && hasAccountForSomeTime && !flagExists && hasStreakToday;
};

export const useMarkNotificationSettingsVisited = () => {
  const { viewer } = useViewerQuery();
  const setFlag = useSetFlag();

  useEffectOnce(() => {
    if (!viewer) return;

    void setFlag({
      name: NOTIFICATION_REENGAGEMENT_FLAG,
      value: "visited",
      ttlDays: TWO_MONTHS_IN_DAYS
    });
  });
};
